import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../../lib/api';
import type { ListResponse } from '../../../lib/useCrud';

type AuditRow = {
  id: string;
  action: string;
  entity_type: string;
  entity_id: string | null;
  created_at: string;
  actor_user_id: string | null;
  actor: { id: string; full_name: string; email: string } | null;
  meta: Record<string, unknown> | null;
};

export function HistoryTab({
  entityType,
  entityId,
}: {
  entityType: string;
  entityId: string;
}) {
  const q = useQuery({
    queryKey: ['audit', entityType, entityId],
    queryFn: () =>
      apiRequest<ListResponse<AuditRow>>(
        `/audit-logs?entity_type=${entityType}&entity_id=${entityId}&limit=100`,
      ),
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {q.isLoading && <div className="card card-body muted">Loading…</div>}
      {q.error && (
        <div className="alert">
          {q.error instanceof Error ? q.error.message : 'Failed to load history'}
        </div>
      )}
      {q.data && q.data.data.length === 0 && (
        <div className="card card-body muted">No history yet.</div>
      )}
      {q.data && q.data.data.length > 0 && (
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>Action</th>
                <th>Actor</th>
                <th>When</th>
                <th>Meta</th>
              </tr>
            </thead>
            <tbody>
              {q.data.data.map((r) => (
                <tr key={r.id}>
                  <td className="cell-mono">{r.action}</td>
                  <td>{r.actor?.full_name ?? <span className="muted">system</span>}</td>
                  <td className="muted">{new Date(r.created_at).toLocaleString()}</td>
                  <td className="muted" style={{ fontSize: 11 }}>
                    {r.meta ? JSON.stringify(r.meta) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
